module.exports = __webpack_public_path__ + "static/media/Tracking_code.598f11ae.svg";